import { FC, useState } from 'react';

import {
  Box,
  Text,
  Flex,
  Image,
  Center,
  Spinner,
  SimpleGrid,
} from '@chakra-ui/react';

import { motion } from 'framer-motion';

import { useQuery } from 'react-query';
import { getPickupImages } from 'api/pickup';
import { Pickup } from 'types/pickup';
import { formatedDate } from 'utils/formatDate';

type Props = {
  isLoading: boolean;
  pickup?: Pickup;
};

const MotionImage = motion(Image);

export const Pictures: FC<Props> = ({ isLoading, pickup }) => {
  const [selected, setSelected] = useState('');

  if (isLoading) {
    return (
      <Center flex={1} p="50px">
        <Spinner size="lg" />
      </Center>
    );
  }

  return (
    <Flex
      w="100%"
      mt="20px"
      flex={1}
      gap="20px"
      maxH="400px"
      overflow="auto"
      fontSize="14px">
      <Flex direction="column" gap="20px">
        <div>
          <Text mb="10px" fontWeight="600" color="#959595">
            Time Collected: {formatedDate(pickup?.pickedUpDate)}
          </Text>
        </div>
        <div>
          <Text mb="10px" fontWeight="600" color="#959595">
            Collected By: {formatedDate(pickup?.pickedUpDate)}
          </Text>
        </div>
        <Box flex={1}>
          <Text mb="10px" fontWeight="600" color="#959595">
            Collection Pictures
          </Text>
          {!isLoading ? (
            <SimpleGrid flex={1} columns={{ base: 2, md: 3 }} spacing="10px">
              {pickup?.proofOfPickupFilesImageUrls &&
                pickup?.proofOfPickupFilesImageUrls.map((p) => {
                  return (
                    <Image
                      key={p}
                      src={p}
                      objectFit="cover"
                      h="100px"
                      w="100px"
                      borderRadius="10px"
                      overflow="hidden"
                      draggable={false}
                      onClick={() => {
                        setSelected((prev) => (prev === p ? '' : p));
                      }}
                      cursor="pointer"
                      opacity={selected === p ? 0.5 : 1}
                    />
                  );
                })}
            </SimpleGrid>
          ) : (
            <Center p="50px">
              <Text fontWeight="500" color="#959595">
                No Pictures uploaded
              </Text>
            </Center>
          )}
        </Box>
        <div
          style={{
            background: '#F6F6F6',
            width: 'auto',
            padding: (pickup?.notes ?? '').length > 0 ? '20px' : '5px',
            borderRadius: (pickup?.notes ?? '').length > 0 ? '10px' : '4px',
            marginBottom: (pickup?.notes ?? '').length > 0 ? '10px' : '0px',
          }}>
          <Text fontWeight="600" color="#959595" mb="10px" fontSize={'14px'}>
            Driver Notes:
          </Text>
          <Text fontWeight="400" mb="10px" fontSize={'16px'}>
            {pickup?.driverNotes ?? '-'}
          </Text>
        </div>
      </Flex>

      {pickup?.proofOfPickupFilesImageUrls &&
        pickup?.proofOfPickupFilesImageUrls.length > 0 && (
          <Center flex={1}>
            <Center
              bg="#f1f1f1"
              h="300px"
              w="300px"
              borderRadius="10px"
              overflow="hidden">
              {Boolean(selected) ? (
                <MotionImage
                  src={selected}
                  objectFit="contain"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                />
              ) : (
                <Text>Select a picture to preview</Text>
              )}
            </Center>
          </Center>
        )}
    </Flex>
  );
};
